export default {
  plural: 'Twin Assets',
  upload: 'Upload asset',
  createTitle: 'Upload asset',
  editTitle: 'Edit asset',
  deleteTitle: 'Delete asset',
  deleteWarning: 'Are you sure you want to delete this asset?',
  deleteInUse:
    'This asset cannot be deleted: it is still used by parts. Unlink it from the parts first.',
  columns: {
    name: 'Name',
    assetType: 'Type',
    company: 'Company',
    mimeType: 'MIME type',
    createdAt: 'Created'
  },
  profile: {
    title: 'Profile',
    parsedAt: 'Parsed at',
    parsedNotSaved: 'Parsed locally, not saved yet',
    isFrameOnly: 'Frame only',
    warnings: 'Warnings',
    mountCorrection: 'Mount orientation',
    mountCorrectionHint:
      'Applied to the connectors before saving. Legs usually need 180° about Z, handles +90° about X.',
    applyMountCorrection: 'Apply orientation',
    sockets: 'Sockets',
    connectors: 'Connectors',
    zones: 'Zones',
    materials: 'Materials',
    reparse: 'Reparse',
    parse: 'Parse',
    noProfileYet: 'No profile yet'
  },
  overrides: {
    open: 'Edit overrides',
    title: 'Profile overrides',
    meshesTitle: 'Meshes',
    meshZoneColumn: 'Zone',
    noZone: '—',
    customZone: 'Custom zone…',
    customZoneHint:
      'Create a zone template with this code to make it selectable',
    nodesTitle: 'Nodes',
    markColumn: 'Mark',
    group: 'Group',
    position: 'Position',
    kind: 'Kind',
    save: 'Save',
    reuploadNote:
      'Overrides are stored on the asset and re-applied on Reparse and re-upload; references to renamed meshes/nodes turn into profile warnings.',
    loadError: 'Failed to load the GLB for editing'
  }
};
